import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ee08ab5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ee08ab5a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee08ab5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee08ab5a')) {
      api.createRecord('ee08ab5a', component.options)
    } else {
      api.reload('ee08ab5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ee08ab5a&scoped=true", function () {
      api.rerender('ee08ab5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/comment/index.vue"
export default component.exports